<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Gebruiker toevoegen
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col>
                        <h5>Basisgegevens</h5>
                        <hr>
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Email">
                          <b-form-input type="email" required v-model="item.email"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Rol">
                          <b-form-select v-model="item.role" :options="roleOptions" required></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-row v-if="item.role === 'p-campaign-manager'">
                      <b-col>
                        <b-form-group label="Provincies">
                          <multiselect edit v-model="item.provinces" :options="provinceOptions" :multiple="true"
                            :close-on-select="true" :searchable="true" :clear-on-select="false"
                            placeholder="Kies provincie(s)" label="text" track-by="value" :preselect-first="true" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-else-if="item.role !== 'admin'">
                      <b-col>
                        <b-form-group label="Gemeentes">
                          <multiselect edit v-model="item.municipalities" :options="municipalityOptions"
                            :multiple="item.role !== 'volunteer'" :close-on-select="true" :searchable="true" :clear-on-select="false"
                            placeholder="Kies gemeente(s)" label="text" track-by="value" :preselect-first="true" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <template slot="footer">
                  <div>
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">
                      Toevoegen</b-button>
                  </div>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getData, addData } from '../../api';
import roles from '../../roles';

export default {
  name: 'user',
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      companyOptions: [],
      item: {
        name: '',
        email: '',
        role: null,
        municipalities: [],
        provinces: []
      },
      municipalityOptions: [],
      provinceOptions: [],
      roleOptions: roles,
    };
  },
  methods: {
    async getItem() {
      const item = await getData('users/' + this.$route.params.id).then(
        (response) => response.data
      );
      this.item = item.data;
    },
    async getMunicipalityOptions() {
      this.municipalityOptions = await getData('municipalities').then(
        (response) => response.data.data
      );
    },
    async getProvinceOptions() {
      this.provinceOptions = await getData('provinces').then(
        (response) => response.data.data
      );
    },
    async saveItem() {
      this.saveButtonDisabled = true;
      const request = await addData(
        'users',
        {
          name: this.item.name,
          email: this.item.email,
          role: this.item.role,
          provinces: this.item.role === 'p-campaign-manager' ? this.item.provinces.map(a => a.value) : [],
          municipalities: this.item.role === 'campaign-manager' ? this.item.municipalities.map(a => a.value) : this.item.role === 'volunteer' ? [this.item.municipalities.value] : [],
        }
      );
      if (request.status === 201) {
        this.$router.push({ name: 'users.view', params: { id: request.data.data.id } });
      } else {
        this.saveButtonDisabled = false;
      }
    },
  },
  beforeMount() {
    this.getMunicipalityOptions();
    this.getProvinceOptions();
  },
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
